import axios from 'axios'
import { RECUSAR_AUTENTICACAO_DOIS_FATORES, USER_AUTHENTICATED } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { getAuthentication, saveSecurityToken } from '../../security/securityContext';

export default function recusaAutenticacaoDoisFatores () {
  const url = `${URL}/usuarios/recusado-autenticacao-dois-fatores`;
    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then((response) => {

      let authentication = getAuthentication();
        const data = response.data.dataRecusaAutenticacaoDoisFatores

        authentication = Object.assign({}, authentication, {          
          dataRecusaAutenticacaoDoisFatores: data
        });

        saveSecurityToken(authentication);

        //Dispatch da Ação de Habilitação (original)
        dispatch({
          type: RECUSAR_AUTENTICACAO_DOIS_FATORES,
          payload: response // ou algo específico se HABILITAR precisar de menos info
        });

        // Dispatch da Ação de Usuário Autenticado (para atualizar o contexto global)
        return dispatch({
          type: USER_AUTHENTICATED,
          payload: authentication
        });
  })



}
